import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BuildForm } from 'src/app/shared/models/formulir/build-form.model';
import { environment } from 'src/environments/environment';
import { BuildFormAdapter } from '../../adapter/formulir/build-form.adapter.service';
import { ClinicEnvironmentService } from '../../clinic-environment.service';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class BuildFormApiService implements ApiService<BuildForm> {
  // ? We don't have any adapter for table data since the data is dynamic and varies.
  // ? Adapter is used to get build form data from dbbidan.build_form table.

  constructor(
    private adapter: BuildFormAdapter,
    private clinicEnv: ClinicEnvironmentService,
    private http: HttpClient
  ) {}

  public getAll(params?: any): Observable<BuildForm[]> {
    const queries = {};
    if (params?.version) queries['version'] = String(params.version);
    if (params?.antrianMedis) queries['antrianMedis'] = String(params.antrianMedis);
    if (params?.idInstallasi) queries['idInstallasi'] = String(params.idInstallasi);
    if (params?.idRuang) queries['idRuang'] = String(params.idRuang);

    const queryParams = new URLSearchParams({ ...queries }).toString();
    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form-detailed?${queryParams}`
      )
      .pipe(
        catchError((err) => throwError(err)),
        map((data: any) => {
          if (!data) return [];
          return (data.responses.buildForm as any[]).map((item: unknown) =>
            this.adapter.adapt(item)
          );
        })
      );
  }

  public getById(id: number): Observable<BuildForm> {
    return this.http
      .get(`${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${id}`)
      .pipe(
        map((data: any) => {
          if (!data) return null;
          return this.adapter.adapt(data.responses.buildForm);
        }),
        catchError((err) => throwError(err))
      );
  }

  public getBuildFormNavigationSuggestions(): Observable<{ heads: string[]; children: string[] }> {
    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/navigation-suggestions`
      )
      .pipe(
        map((data: any) => {
          return {
            heads: data?.responses?.heads || [],
            children: data?.responses?.children || [],
          };
        }),
        catchError((err) => throwError(err))
      );
  }

  public createBuildForm(data: any): Observable<any> {
    return this.http
      .post(`${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form`, { ...data })
      .pipe(
        map((resp) => {
          return {
            ...resp,
          };
        }),
        catchError((err) => throwError(err))
      );
  }

  public update(idBuildForm: number, data: any): Observable<any> {
    return this.http
      .patch(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${idBuildForm}`,
        { ...data }
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public getFromSourceTableById(idBuildForm: number, idItem: number | string) {
    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${idBuildForm}/table-data/${idItem}`
      )
      .pipe(
        catchError((err) => throwError(err)),
        map((data: any) => {
          if (!data) return null;
          return data.responses.tableData;
        })
      );
  }

  public getFromSourceTable(params?: any) {
    let queryParams = '';
    const idBuildForm = params['idBuildForm'];
    delete params['idBuildForm'];
    const qp = {
      ...params,
    };
    Object.keys(qp).forEach((key) => (qp[key] === undefined ? delete qp[key] : {}));
    queryParams = new URLSearchParams(qp).toString();

    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${idBuildForm}/table-data?${queryParams}`
      )
      .pipe(
        map((data: any) => {
          if (!data) return [];
          return data.responses.tableData as any[];
        }),
        catchError((err) => throwError(err))
      );
  }

  public insertToSourceTable(idBuildForm: number, data: any) {
    return this.http
      .post(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${idBuildForm}/table-data`,
        data
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public updateDataSourceTable(idBuildForm: number, idItem: number | string, data: any) {
    return this.http
      .patch(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/build-form/${idBuildForm}/table-data/${idItem}`,
        data
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public deleteBuildForm(idBuildForm: number) {
    return this.http
      .patch(`${environment.urlV2}/build-form/${idBuildForm}/hide`, {})
      .pipe(catchError((err) => throwError(err)));
  }
}
